import { priceStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { typography } from "@solveindustrial/Utilities/styleguide";
import { css } from "styled-components";

styles.productPrice = {
    ...styles.productPrice,
    price: {
        ...styles.productPrice?.price,
        priceText: {
            ...styles.productPrice?.price?.priceText,
            ...typography.h2,
            variant: "h2",
            weight: 700,

            css: css`
                ${styles.productPrice?.price?.priceText?.css}
                ${typography.h2.css}
                margin: 0;
            `,
        },
    },
    priceWrapper: {
        ...styles.productPrice?.priceWrapper,
        css: css`
            ${styles.productPrice?.priceWrapper?.css}
            display: flex;
            align-items: center;
        `,
    },
};
